// Read VITE_* env at module load and validate. Crash early if anything's missing.

import type { FirebaseConfig } from "@goodbye/firebase";

function required(key: string): string {
  const v = import.meta.env[key];
  if (!v || typeof v !== "string") {
    throw new Error(
      `[env] Missing required env var ${key}. Did you copy .env.example to .env.local?`,
    );
  }
  return v;
}

function optional(key: string): string | undefined {
  const v = import.meta.env[key];
  return typeof v === "string" && v.length > 0 ? v : undefined;
}

export const env = {
  firebase: {
    apiKey: required("VITE_FIREBASE_API_KEY"),
    authDomain: required("VITE_FIREBASE_AUTH_DOMAIN"),
    projectId: required("VITE_FIREBASE_PROJECT_ID"),
    storageBucket: required("VITE_FIREBASE_STORAGE_BUCKET"),
    messagingSenderId: required("VITE_FIREBASE_MESSAGING_SENDER_ID"),
    appId: required("VITE_FIREBASE_APP_ID"),
  } satisfies FirebaseConfig,
  stadiaApiKey: required("VITE_STADIA_API_KEY"),
  // Where the learner app lives, used for the "preview as learner" link in
  // the admin footer. Falls back to prod when unset (local dev → prod link is
  // fine; the worker can manually swap to localhost:5173 in URL bar).
  userOrigin: optional("VITE_USER_ORIGIN") ?? "https://echo.dace.com.tw",
  useEmulators: import.meta.env.VITE_USE_EMULATORS === "true",
  // Sentry DSN (optional). Same project / DSN as the user app so worker
  // errors land in the same backlog. No-op when unset.
  sentryDsn: optional("VITE_SENTRY_DSN"),
  release: optional("VITE_RELEASE") ?? "dev",
} as const;
